import { CircularCheckbox } from 'components/CircularCheckbox'
import React, { PropsWithChildren } from 'react'
import {
  Control,
  Controller,
  UseFormSetValue,
  UseFormWatch,
} from 'react-hook-form'
import { SubtitleColorType } from 'service/list'
import { FormValues } from 'utils/type'

interface SubtitleSizeProps {
  subtitleSizeList: SubtitleColorType[] | []
  watch: UseFormWatch<FormValues>
  setValue: UseFormSetValue<FormValues>
  control: Control<FormValues, any>
}
export const SubtitleSize = ({
  subtitleSizeList,
  watch,
  setValue,
  control,
}: PropsWithChildren<SubtitleSizeProps>) => {
  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-[18px] text-left">크기</p>
      <div className="grid grid-cols-2 md:grid-cols-3  gap-x-[22px] gap-y-[16px] ">
        {subtitleSizeList?.map((subtitleSize, index) => {
          return (
            <>
              <div
                className="flex flex-col cursor-pointer gap-2"
                key={`subtitle_size_${index}`}
                onClick={() => {
                  setValue('subtitleSizeId', subtitleSize.id)
                }}
              >
                <img src={subtitleSize?.imagePath} alt="" />
                <Controller
                  render={({ field }) => (
                    <CircularCheckbox
                      {...field}
                      id={index}
                      checked={watch('subtitleSizeId') === subtitleSize.id}
                      onChange={() => {}}
                      label={subtitleSize?.name}
                    />
                  )}
                  name="subtitleSizeId"
                  control={control}
                />
              </div>
            </>
          )
        })}
      </div>
    </div>
  )
}
